export const CUSTOMER_DETAILS_TABS_ID = {
  ACCOUNT_TAB_ID: 'account',
  SERVICES_TAB_ID: 'services',
  BILLING_TAB_ID: 'billing',
  FEES_TAB_ID: 'fees',
  ACTIVITY_TAB_ID: 'activity',
}

export const CUSTOMER_DETAILS_TABS_ID_LIST = Object.values(CUSTOMER_DETAILS_TABS_ID)
